import localizationServiceProxy from "./localizationServiceProxy";
import cookie from "./storageManager/methods/cookie";
import session from "./storageManager/methods/session";
import {
  getThdLocalizer,
  setThdLocalizer,
} from "./storageManager/storageManager";
import {
  CATEGORIES,
  EXTERNAL_USERS,
  INTERNAL_USERS,
  STORAGE_IDENTIFIERS,
  TIMESPANS,
  WORKFLOWS,
  WORKFLOW_MAP,
} from "./common/constants";


const userService = {
  status: {
    getAccuracy() {
      const workflow = WORKFLOW_MAP[this.getWorkflow()];
      return workflow?.accuracy || "";
    },
    getGpsStatus() {
      return session.get(STORAGE_IDENTIFIERS.GPS_STATUS);
    },
    getLocalizationMethod() {
      const workflow = WORKFLOW_MAP[this.getWorkflow()];
      return workflow?.alias || "";
    },
    getWorkflow() {
      const { WORKFLOW } = getThdLocalizer() || {};
      return WORKFLOW;
    },
    getSessionToPreventUserInStoreCall() {
      return cookie.get(STORAGE_IDENTIFIERS.IN_STORE_API_SESSION);
    },
    getStoreNumberIfUserIsInsideStore() {
      return cookie.get(STORAGE_IDENTIFIERS.IN_STORE_USER_NUMBER);
    },
    isAutoLocalized() {
      const { THD_FORCE_LOC } = getThdLocalizer() || {};
      return THD_FORCE_LOC === CATEGORIES.THD_FORCE_LOC.AUTO_LOCALIZED;
    },
    isDefaultLocalized() {
      const { THD_FORCE_LOC } = getThdLocalizer() || {};
      return (
        THD_FORCE_LOC === CATEGORIES.THD_FORCE_LOC.DEFAULT ||
        THD_FORCE_LOC === undefined ||
        THD_FORCE_LOC === ""
      );
    },
    isExternal(workflow) {
      workflow = workflow || this.getWorkflow();
      const { THD_INTERNAL } = getThdLocalizer() || {};
      return (
        (workflow && EXTERNAL_USERS.includes(workflow)) ||
        THD_INTERNAL === CATEGORIES.THD_INTERNAL.EXTERNAL
      );
    },
    isInternal(workflow) {
      workflow = workflow || this.getWorkflow();
      const { THD_INTERNAL } = getThdLocalizer() || {};
      return (
        (workflow && INTERNAL_USERS.includes(workflow)) ||
        THD_INTERNAL === CATEGORIES.THD_INTERNAL.INTERAL
      );
    },
    async isInternalAsync() {
      try {
        const response = await localizationServiceProxy.getMetadata();
        if (INTERNAL_USERS.includes(response.metadata.workflow)) {
          setThdLocalizer({
            entries: {
              [STORAGE_IDENTIFIERS.THD_LOCALIZER.THD_INTERNAL]:
                CATEGORIES.THD_INTERNAL.INTERAL,
            },
          });
          return true;
        } else {
          setThdLocalizer({
            entries: {
              [STORAGE_IDENTIFIERS.THD_LOCALIZER.THD_INTERNAL]:
                CATEGORIES.THD_INTERNAL.EXTERNAL,
            },
          });
          throw false;
        }
      } catch (e) {
        console.error("Is internal async error: ", e);
        throw false;
      }
    },
    isLocalized() {
      const workflow = this.getWorkflow();
      const { THD_LOCSTORE } = getThdLocalizer() || {};
      return !!(
        workflow &&
        THD_LOCSTORE &&
        (this.isSelfLocalized() ||
          this.isAutoLocalized() ||
          this.isDefaultLocalized())
      );
    },
    isNotLocalized() {
      return !this.isLocalized();
    },
    isRequestFromConsumerApp() {
      return navigator.userAgent.includes("THDConsumer");
    },
    isSelfLocalized() {
      const { THD_FORCE_LOC } = getThdLocalizer() || {};
      return THD_FORCE_LOC === CATEGORIES.THD_FORCE_LOC.SELF_LOCALIZED;
    },
    isStoreHoursExpired() {
      const { THD_STORE_HOURS_EXPIRY } = getThdLocalizer() || {};
      return new Date().getTime() > THD_STORE_HOURS_EXPIRY * 1000;
    },
    isUnknownUser() {
      const { THD_INTERNAL } = getThdLocalizer() || {};
      return THD_INTERNAL === undefined;
    },
    isUserInStore() {
      return this.getWorkflow() === WORKFLOWS.THD_STORE_LOCATION;
    },
    async isUserInStoreAsync() {
      try {
        const response = await localizationServiceProxy.getMetadata();
        if (WORKFLOWS.THD_STORE_LOCATION === response.metadata.workflow) {
          return true;
        } else {
          throw false;
        }
      } catch (e) {
        console.error("Is user in store async error: ", e);
        throw false;
      }
    },
  },

  operations: {
    markAsCanadianUser() {
      cookie.put({
        key: STORAGE_IDENTIFIERS.THD_CA_USER,
        value: 1,
        expireTime: TIMESPANS.SIX_HUNDRED_DAYS,
      });
      cookie.put({
        key: STORAGE_IDENTIFIERS.THD_AUTOLOCINTERCEPT,
        value: 1,
        expireTime: TIMESPANS.SIX_HUNDRED_DAYS,
      });
    },
    markAsInStoreUser(workflow) {
      if (workflow === WORKFLOWS.THD_STORE_LOCATION) {
        cookie.put({
          key: STORAGE_IDENTIFIERS.THD_INSTORE,
          value: "TRUE",
          expireTime: TIMESPANS.SESSION
        });
      }
    },
    setGpsStatus(gpsStatus) {
      session.put({
        key: STORAGE_IDENTIFIERS.GPS_STATUS,
        value: gpsStatus,
      });
    },
    setStoreNumberIfUserIsInsideStore(storeNumber) {
      cookie.put({
        key: STORAGE_IDENTIFIERS.IN_STORE_USER_NUMBER,
        value: storeNumber,
        expireTime: TIMESPANS.FIVE_MINUTES,
      });
    },
    setSessionToPreventUserInStoreCall() {
      cookie.put({
        key: STORAGE_IDENTIFIERS.IN_STORE_API_SESSION,
        value: "TRUE",
        expireTime: TIMESPANS.FIVE_MINUTES,
      });
    },
  },
};

export default userService;
